import {
    RegimeButtons,
    ScheduleSelectorBeforeList,
    ScheduleSelectorPanel,
    ScheduleSelectorToolbarStart,
} from "slot-definitions"
import { isInRegime } from "routes/facilities/lib/when-parent-item"
import { ButtonGroup } from "@mui/material"
import { lazy } from "react"
import { CleanSearchTerm, ScheduleHeaderWrapper } from "event-definitions"
import { OneCard } from "lib/@components/one-card"
import { SearchFilter } from "routes/facilities/plugins/profiles/search-filter"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { removeHash } from "../helpers/remove-hash-from-start"

const Stats = lazy(() => import("./stats"))

ScheduleSelectorBeforeList("*").plug(<Stats priority={600} if={isInRegime} />)
ScheduleSelectorToolbarStart("*").plug(<Regime priority={1000} if={isInRegime} />)
ScheduleSelectorPanel("*").plug(<SearchFilter if={isInRegime} priority={1100} />)

CleanSearchTerm.handle(removeHash)

ScheduleHeaderWrapper("*").handleOnce(({ parentItem }) => {
    if (isInRegime(parentItem)) {
        return { wrapper: <OneCard /> }
    }
    return null
})

function Regime() {
    const { isRegimeSyncedToRegister, isUnlocked } = useBoundContext()
    const regimeButtons = RegimeButtons.useSlot()
    return (!isRegimeSyncedToRegister || isUnlocked) && <ButtonGroup size="small">{regimeButtons}</ButtonGroup>
}
